import { SESSION_MODE_OPTIONS } from './sessionMode';

export function userHasMyHospitalModule(user) {
  if (user?.modules && typeof user.modules.my_hospital === 'boolean') {
    return user.modules.my_hospital;
  }
  return user?.myHospital === true;
}

export function userHasNursingModule(user) {
  return user?.modules?.nursing === true;
}

export function sessionModeOptionsForUser(user) {
  if (userHasNursingModule(user)) {
    return SESSION_MODE_OPTIONS;
  }
  return SESSION_MODE_OPTIONS.filter((option) => option.value !== 'nurse');
}
